import './index.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './Layout'; 
import './App.css';
import Teste from './Teste';
import Politique from './Politique';
import Home from './Home';
import { AlteradoProvider } from './AlteradoProvider';
import Outils from './Outils';
import ProjetTest from './ProjetTest';
import Contact from './Contact';
import LesObjetifs from './LesObjectives';
import VoixAssociations from './VoixAssociations';
import Apropros from './Apropos';
import DynamismeBonnevoie from './DynamismeBonnevoie';

function App() {
  return (
    
  <AlteradoProvider>
    

    <div className="background-container">

      <Router>
      <Routes>
      <Route path="/" element={<ProjetTest/>}></Route>

     <Route path="/associations" element={<Layout/>}>
          <Route index element={<Home />} /> 
        </Route>
     

     <Route path="/quiz" element={
           <div>
             <Layout />
           </div>}>
          <Route index element={<Teste />} /> 
        </Route>
      <Route path="/politique-de-confidentialite" element={ <Layout></Layout>}>
        <Route index element={<Politique></Politique>}></Route>
      </Route>
       <Route path="/outils" element={
           <div>
             <Layout />
           </div>}>
          <Route index element={<Outils />} /> 
        </Route>
        <Route path="/contact" element={
           <div>
             <Layout />
           </div>}>
          <Route index element={<Contact />} />
        </Route>
          <Route path="/lesobjectifs" element={<LesObjetifs/>}></Route>


       {/*  <Route path="/lesobjectifs" element={
           <div>
             <Layout />
           </div>}>
          <Route index element={<LesObjetifs/>} />
        </Route> */}

        <Route path="/voixassociations" element={<VoixAssociations/>}></Route>
        <Route path="/apropros" element={
           <div>
             <Layout />
           </div>}>
          <Route index element={<Apropros/>} /> 
        </Route>
        <Route path="/dynamismebonnevoie" element={<DynamismeBonnevoie/>}></Route>       

      </Routes>
    </Router>
    </div>
  
   </AlteradoProvider> 
  );
}

export default App;
